/**
 * === 檔案用途區塊 ===
 * @module TelegramLogin
 * @purpose 處理 Telegram 第三方登入導轉，於元件載入後立即導向 SSO 登入入口。
 * @external https://innotech.atlassian.net/browse/IN-93752
 * @external https://innotech.atlassian.net/browse/IN-89368
 * @external https://innotech.atlassian.net/browse/IN-54243
 * @external https://innotech.atlassian.net/browse/IN-54205
 * @external https://innotech.atlassian.net/browse/IN-52139
 */

import React, { useEffect } from 'react';
import { useThirdPartyProvider } from '@shared/models';
import { Page } from '@shared/enums/route.enum';
import { getSsoUrl } from '@utilities/helpers/ssoUrl.helper';

/**
 * === 宣告內容用途說明與單號關聯 ===
 * @description Telegram 登入頁元件。
 * @purpose 在元件初始化時觸發登入導轉流程，避免停留於中介頁。
 * @external https://innotech.atlassian.net/browse/IN-89368
 */
const TelegramLogin = () => {
  /**
   * === 宣告內容用途說明與單號關聯 ===
   * @description 取得第三方登入所需參數。
   * @purpose 讀取 provider 狀態中的 clientId 與 redirectUrl，供 SSO URL 組裝。
   * @external https://innotech.atlassian.net/browse/IN-89368
   */
  const { payload } = useThirdPartyProvider();

  /**
   * === 宣告內容用途說明與單號關聯 ===
   * @description 執行 Telegram SSO 導轉。
   * @purpose 以 location.replace 導向登入頁，降低返回中介頁時再次觸發流程的風險。
   * @external https://innotech.atlassian.net/browse/IN-89368
   */
  const login = () => {
    location.replace(
      getSsoUrl(Page.Telegram, {
        clientId: payload.clientId!,
        redirectUrl: payload.redirectUrl!,
      }),
    );
  };

  useEffect(() => login());

  return <></>;
};

export default TelegramLogin;

/**
 * === llm 分析紀錄區 ===
 * @llm-review-submitted-at 2026-06-14T07:14:25.758Z
 * @llm-review-model gpt-5.3-codex
 * @llm-review-note 已僅調整註解並完成三段式重構：移除重複/錯置區塊、統一標題格式與標籤；頂部保留檔案層級 external，宣告層級 external 僅使用 declarationOrigins 的 IN-89368，底部保留單一 llm 分析紀錄區。程式執行邏輯未變更。
 */
